import { Info } from "lucide-react";

interface TransferAlertProps {
  title: string;
  message: string;
}

export default function TransferAlert({
  title,
  message,
}: TransferAlertProps) {
  return (
    <div className="w-full rounded-2xl border border-yellow-300 bg-yellow-50 px-5 py-4">
      <div className="flex items-start gap-3">
        <div className="mt-1 flex h-6 w-6 items-center justify-center text-amber-700">
          <Info size={18} />
        </div>

        <div>
          <h3 className="text-[15px] font-semibold text-amber-900">
            {title}
          </h3>

          <p className="mt-1 text-sm text-amber-800 leading-relaxed">
            {message}
          </p>
        </div>
      </div>
    </div>
  );
}